export default __webpack_public_path__ + "static/media/b.e12be0e0ca647ebe16bb2e16ac58eb42.mp3";